import { AuthData } from "api/resources/users/types"
import { transformKeys } from "api/utils"
import camelCase from "lodash/camelCase"
import { BROWSER_STORAGE_KEYS, IS_LOCALHOST } from "utils/constants"

import CookieHelper, { CookieKeys } from "./cookies"

export function saveAuthInfo(authInfo: AuthData) {
  const { auth } = BROWSER_STORAGE_KEYS
  if (IS_LOCALHOST) {
    localStorage.setItem(auth, JSON.stringify(authInfo))
  } else CookieHelper.set(CookieKeys.studentAuth, JSON.stringify(authInfo))
}

export function getAuthInfo(options?: {
  // keyName?: ValueOf<typeof BROWSER_STORAGE_KEYS>
  keyName?: string
  from?: "cookie" | "localStorage"
}) {
  if (IS_LOCALHOST) {
    options = { ...options, from: "localStorage" }
  }
  if (!options?.keyName) {
    options = { ...options, keyName: BROWSER_STORAGE_KEYS.auth }
  }

  const { keyName } = options
  if (!keyName) throw new Error("Key name is required")

  const useLocalStorage = options?.from === "localStorage"

  let authInfo: string | null = null
  if (keyName === BROWSER_STORAGE_KEYS.auth) {
    authInfo = useLocalStorage
      ? localStorage.getItem(keyName) || sessionStorage.getItem(keyName)
      : CookieHelper.get(CookieKeys.studentAuth)
  } else {
    // This log is only temporarily here so that we can check if the project is still somehow using localstorage despite me having implemented cookie auth
    if (!IS_LOCALHOST)
      console.log(`> Getting auth info from localStorage: ${keyName}`)
    authInfo = localStorage.getItem(keyName) || sessionStorage.getItem(keyName)
  }

  if (authInfo !== null) {
    const newAuthInfoObj: AuthData = transformKeys(
      JSON.parse(authInfo),
      camelCase
    )
    return newAuthInfoObj
  }

  return authInfo
}

export function clearAuthInfo() {
  const { auth } = BROWSER_STORAGE_KEYS
  CookieHelper.remove(CookieKeys.studentAuth)
  localStorage.removeItem(auth)
}

export const generateLoginURL = ({
  redirectUrl,
  next,
  ...rest
}: { redirectUrl: string; next: string } & { [key: string]: string }) => {
  const SSO_URL = import.meta.env.VITE_SSO_URL

  let redirectTo = encodeURIComponent(redirectUrl)
  if (next) redirectTo = `${redirectTo}?next=${encodeURIComponent(next)}`

  const restParams = Object.keys(rest)
    .map(key => `${key}=${rest[key]}`)
    .join("&")
  const url = `${SSO_URL}/?redirect-url=${redirectTo}&${restParams}`

  return url
}
